<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <div v-show="almost_mobile" style="margin-top: 10%"></div>
      <h3
        :class="almost_mobile ? 'pt-3 pl-2' : 'pb-2 pt-3 pl-2'"
        style="color: #00a99d; font-size: 25px"
      >
        รายการจ่ายยา
      </h3>
      <div style="margin-top: 20px"></div>

      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="card-search">
          <v-text-field
            v-model="search"
            class="card-search"
            label="ค้นหาชื่อ/รหัสพนักงาน/หมายเลขโทรศัพท์"
            dense
            solo
            hide-details
            append-icon="mdi-magnify"
            color="#00a99d"
            @keyup="searchPrescription"
            clearable
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="px-0">
          <v-btn
            color="#00a99d"
            dark
            block
            style="border-radius: 20px 5px; color: #fff"
            max-width="120"
            @click="prescptOpen"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>จ่ายยา
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemSearch"
        item-key="created_by"
        hide-default-footer
      >
        <template v-slot:no-data>
          <span class="font-16">ไม่มีข้อมูลรายการจ่ายยา </span>
        </template>
        <template v-slot:item.no="{ item }">
          <span class="font-16">{{
            page > 1
              ? (page - 1) * 10 + itemSearch.indexOf(item) + 1
              : itemSearch.indexOf(item) + 1
          }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="font-16">{{
            item.patient ? item.patient.fullname : "-"
          }}</span>
        </template>
        <template v-slot:item.gender="{ item }">
          <span class="font-16">{{
            item.patient ? displayItem(item.patient, "gender") : "-"
          }}</span>
        </template>
        <template v-slot:item.age="{ item }">
          <span class="font-16">{{
            item.patient && item.patient.birth_date !== null
              ? displayItem(item.patient, "age")
              : "-"
          }}</span>
        </template>
        <template v-slot:item.mobile="{ item }">
          <span class="font-16">{{
            item.patient ? displayItem(item.patient, "mobile") : "-"
          }}</span>
        </template>
        <template v-slot:item.latest="{ item }">
          <span class="font-16">{{
            item.patient ? displayDate(item.last_time) : "-"
          }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end py-2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    v-bind="attrs"
                    color="#00a99d"
                    icon
                    @click.stop="historyOpen(item)"
                  >
                  <v-chip>
                    <v-icon color="#00a99d"
                      >mdi-clipboard-account-outline</v-icon
                    ></v-chip>
                  </v-btn>
                </div>
              </template>
              <span>ข้อมูลผู้ป่วย</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.status_waiting">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  class="ml-4"
                  color="#00a99d"
                  @click="prescptConfirm(item)"
                >
                <v-chip>
                  <v-icon color="primary">mdi-pill-multiple</v-icon>
                  <v-badge dot color="green"> </v-badge>
                </v-chip>
                </v-btn>
              </template>
              <span>ยืนยันรายการยา</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <Pagination :totals="total" :isPage="page" @page="changePage" />
      <HistoryPrescription ref="HistoryPrescription" />
      <DialogPrescription
        ref="DialogPrescription"
        @success="searchPrescription()"
      />
      <DialogPrescriptionConfirm
        ref="DialogPrescriptionConfirm"
        @success="searchPrescription()"
      />
    </v-container>
  </div>
</template>
<script>
import { Pagination } from "@/components/pagination";
import HistoryPrescription from "@/components/dialog/HistoryPrescription.vue";
import DialogPrescription from "@/components/dialog/DialogPrescription.vue";
import DialogPrescriptionConfirm from "@/components/dialog/DialogPrescriptionConfirm.vue";
import moment from "moment";
export default {
  components: {
    Pagination,
    HistoryPrescription,
    DialogPrescription,
    DialogPrescriptionConfirm,
  },
  data: () => ({
    search: "",
    headers: [
      {
        text: "ลำดับ",
        value: "no",
        sortable: false,
        align: "center",
      },
      {
        text: "ชื่อผู้ป่วย",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "เพศ",
        align: "center",
        sortable: false,
        value: "gender",
      },
      {
        text: "อายุ",
        align: "center",
        sortable: false,
        value: "age",
      },
      {
        text: "หมายเลขโทรศัพท์",
        align: "center",
        sortable: false,
        value: "mobile",
      },
      {
        text: "จ่ายยาครั้งล่าสุด",
        value: "latest",
        sortable: false,
        align: "center",
        width: "20%",
      },
      {
        text: "จัดการ",
        align: "center",
        sortable: false,
        value: "action",
        width: "8%",
      },
    ],
    page: 1,
    total: 0,
    itemSearch: [],
  }),
  async created() {
    await this.searchPrescription();
  },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 960) {
        return true;
      } else {
        return false;
      }
    },
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่มรายการยา" : "แก้ไขรายการยา";
    },
  },
  watch: {
    search(val) {
      if (val == null) {
        this.searchPrescription("");
      }
    },
  },
  methods: {
    prescptOpen() {
      this.$refs.DialogPrescription.open();
    },
    prescptConfirm(item) {
      this.$refs.DialogPrescriptionConfirm.open(item);
    },
    changePage(e) {
      this.page = e;
      this.searchPrescription();
    },
    historyOpen(item) {
      this.$refs.HistoryPrescription.open(item);
    },
    displayItem(item, type) {
      const { account_title_th, birth_date, mobile } = item;
      switch (type) {
        case "gender":
          if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
          if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
            return "หญิง";
          break;
        case "age":
          if (birth_date) {
            const y = Math.floor(
              moment.duration(moment().diff(birth_date)).asYears()
            );
            return y;
          }
          break;
        case "mobile":
          if (mobile) {
            return mobile;
          }
          break;
      }
    },
    displayDate(date) {
      if (!date) return "-";
      return moment(date).locale("th").add(543, "years").format("DD MMMM YYYY");
    },
    async searchPrescription(search) {
      try {
        let word = "";
        if (search === undefined) {
          word = "";
        } else if (search === "") {
          word = "";
        } else word = search.target.value;

        const params = new URLSearchParams();
        params.append("page", this.page || 1);
        params.append("limit", 10);
        params.append("biz_id", sessionStorage.biz_id);
        params.append("search", word || "");
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/prescription-group?${params}`
          )
          .then((res) => {
            if (res.data) {
              let patientList = res.data.data[0].data;
              patientList.forEach((element) => {
                if (element.patient) {
                  const {
                    account_title_th = "",
                    first_name_th = "",
                    last_name_th = "",
                  } = element.patient;
                  element.patient.fullname =
                    `${account_title_th} ${first_name_th} ${last_name_th}`.trim();
                }
              });
              this.itemSearch = [...patientList];
              this.total = res.data.data[0].metadata[0].total;
              // console.log("itemSearch", this.itemSearch);
            }
          });
      } catch (error) {
        console.error();
      }
    },
  },
};
</script>
<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-download {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
</style>
